import React from 'react'
import { DesktopFeatureModal } from './DesktopFeatureModal'
import { MobileFeatureModal } from './MobileFeatureModal'

export const FeatureModal: React.VFC<{ isMobile: boolean }> = ({ isMobile }) => (isMobile ? <MobileFeatureModal /> : <DesktopFeatureModal />)
